<template>
  <div id="app">
    <!--img src="./assets/logo.png"-->
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="/" id="brand">
        <img src="./assets/logo.png" width="30">
        Hanheung Industrial Co.
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="greeting">인사말</b-nav-item>
          <b-nav-item href="intro">회사 소개</b-nav-item>
          <b-nav-item href="product">제품 소개</b-nav-item>
          <b-nav-item href="contact">오시는 길</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view/>
    <b-jumbotron lead="(주) 한 흥 실 업" align="left">
      <p class="mb-0">전화 <a href="tel:02-783-8921">02-783-8921~3</a></p>
      <p class="mb-0">팩스 02-783-8926</p>
      <p class="mt-0 mb-0">서울시 성동구 성수일로 99 AK밸리 706호 </p>
      <p class="mt-0">충청북도 괴산군 연풍면 은티중리길 248 </p>
      <p class="mb-0">email h7838922@naver.com </p>
      <!--b-button variant="primary" href="#">More Info</b-button-->
    </b-jumbotron>
    <b-navbar type="dark" variant="dark" style="position:fixed;left:0;bottom:0;width:100%;">
      <b-navbar-nav style="font-size:10px">
        <b-nav-text> COPYRIGHT Hanheung Industrial Co. ALL RIGHTS RESERVED </b-nav-text>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue